import { render, staticRenderFns } from "./ColorPickerTool.vue?vue&type=template&id=6db8b847&"
import script from "./ColorPickerTool.vue?vue&type=script&lang=js&"
export * from "./ColorPickerTool.vue?vue&type=script&lang=js&"
import style0 from "./ColorPickerTool.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports